import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type ActionsTypePropsT = { name: string; data: unknown };
const savedData = createSlice({
  name: 'common/idsSelectors',
  initialState: {
    storage: {} as Record<string, unknown>,
  },
  reducers: {
    setStorageData: (state, action: PayloadAction<ActionsTypePropsT>) => {
      const hash = state.storage;
      const entityName = action.payload.name;

      hash[entityName] = action.payload.data;
    },
    removeStorageData: (state, action: PayloadAction<Pick<ActionsTypePropsT, 'name'>>) => {
      const hash = state.storage;
      const entityName = action.payload.name;

      hash[entityName] && delete hash[entityName];
    },
  },
});
export const savedDataReducer = savedData.reducer;
export const { setStorageData, removeStorageData } = savedData.actions;
